import { useState } from 'react';
import { Dialog, DialogActions, DialogContent } from '@mui/material';
import { renderHTML } from '@agility/nextjs';
import { KitButton } from 'components/common/cms-kit';

const CLICK_HERE_TEXT = 'click here';

const AIDisclaimer = ({
  linkText,
  disclaimer,
}: {
  linkText: string;
  disclaimer: string;
}) => {
  const lowerLinkText = linkText ? linkText.toLowerCase() : '';
  const [disclaimerOpen, setDisclaimerOpen] = useState<boolean>(false);

  return (
    <>
      {linkText && lowerLinkText.indexOf(CLICK_HERE_TEXT) !== -1 ? (
        // split the text to remove "Click here" and add a span around it
        (<>
          {linkText.substring(0, lowerLinkText.indexOf(CLICK_HERE_TEXT)).trim()}
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              setDisclaimerOpen(true);
            }}
            style={{
              textDecoration: 'underline',
              cursor: 'pointer',
              marginLeft: '.5ch',
              marginRight: '.5ch',
              background: 'none',
              border: 'none',
              padding: 0,
              color: 'inherit',
              font: 'inherit',
            }}
            aria-label="Open AI Disclaimer"
          >
            {CLICK_HERE_TEXT}
          </button>
          {linkText
            .substring(
              lowerLinkText.indexOf(CLICK_HERE_TEXT) + CLICK_HERE_TEXT.length,
            )
            .trim()}
        </>)
      ) : (
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            setDisclaimerOpen(true);
          }}
          style={{
            textDecoration: 'underline',
            cursor: 'pointer',
            background: 'none',
            border: 'none',
            padding: 0,
            color: 'inherit',
            font: 'inherit',
          }}
          aria-label="Open AI Disclaimer"
        >
          {linkText || 'Click here for AI Disclaimer'}
        </button>
      )}
      <Dialog
        maxWidth="sm"
        scroll="paper"
        fullWidth={false}
        open={disclaimerOpen}
        onClose={() => setDisclaimerOpen(false)}
      >
        <DialogContent>
          <div
            className="prose"
            style={{ marginTop: '-50px' }}
            dangerouslySetInnerHTML={renderHTML(disclaimer)}
          ></div>
        </DialogContent>
        <DialogActions>
          <KitButton
            onClick={() => setDisclaimerOpen(false)}
            size="sm"
            round
            color="success"
          >
            OK
          </KitButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AIDisclaimer;
